import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TokenInterceptor } from '../../../../token.interceptor';
import { MfToastService } from '../../../../_shared/services';
import { ComponentModule } from '../../../components/component.module';
import { LayoutModule } from '../../../layouts/layout.module';
import { HomeComponent } from '../home.component';
import { IndexService, NotificationService, TaskService } from '../_services';
import { BasicComponentsModule } from './../../../basic-components/basic-components.module';
import { MainCalendarModule } from './../main-calendar/main-calendar.module';
import { InxKabItemComponent } from './index-kanban/components/inx-kab-item/inx-kab-item.component';
import { IndexKanbanComponent } from './index-kanban/index-kanban.component';
import { IndexTasksComponent } from './index-tasks/index-tasks.component';
import { IndexComponent } from './index.component';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        children: [
            {
                path: '',
                component: IndexComponent,
            },
        ],
    },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        LayoutModule,
        ComponentModule,
        NgxPermissionsModule,
        NgxDatatableModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        DragDropModule,
        NgScrollbarModule,
        MainCalendarModule,
        BasicComponentsModule,
    ],

    exports: [RouterModule],

    declarations: [IndexComponent, IndexTasksComponent, IndexKanbanComponent, InxKabItemComponent],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        IndexService,
        TaskService,
        NotificationService,
        MfToastService,
    ],
})
export class IndexModule {}
